import { useLocation } from "react-router-dom";
import ConnectPage from "../components/ConnectPage";

export default function Connect() {
  const location = useLocation();
  const state = location.state as {
    specTitle: string;
    baseUrl: string;
    serverPath: string;
    mcpUrl?: string;
    sseUrl?: string;
  } | null;

  return (
    <main className="min-h-screen bg-gray-50 py-10">
      <ConnectPage
        specTitle={state?.specTitle || "my-api"}
        baseUrl={state?.baseUrl || "https://api.example.com"}
        serverPath={state?.serverPath || "server.py"}
        mcpUrl={state?.mcpUrl}
        sseUrl={state?.sseUrl}
      />
    </main>
  );
}